import { AGENCY_CSV_COLUMNS } from "./agencyExportConfig"
import { AgencyAgentExportRow } from "./agencyExportTypes"
import { buildCsv, CsvExportColumn, downloadCsv } from "./csvExport"

export interface AgencyCsvExportOptions {
  /** Defaults to `AGENCY_CSV_COLUMNS`. Pass a custom list to trial another layout. */
  columns?: CsvExportColumn<AgencyAgentExportRow>[]
  /** Defaults to `agency-YYYY-MM-DD-HH-MM.csv`. */
  filename?: string
}

const defaultFilename = (): string => {
  const date = new Date()
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const dd = String(date.getDate()).padStart(2, "0")
  const hh = String(date.getHours()).padStart(2, "0")
  const min = String(date.getMinutes()).padStart(2, "0")
  return `agency-${yyyy}-${mm}-${dd}-${hh}-${min}.csv`
}

export const exportAgencyAgentRowsToCsv = (
  rows: AgencyAgentExportRow[],
  options: AgencyCsvExportOptions = {},
): void => {
  const columns = options.columns ?? AGENCY_CSV_COLUMNS
  const csv = buildCsv(rows, columns)
  downloadCsv(csv, options.filename ?? defaultFilename())
}
